import { Component, isDevMode } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Login } from '../../models/Login.model';
import { LoginService } from 'src/app/services/login.service';
import { PermissionService } from 'src/app/services/permission.service';
import { Alert } from 'src/app/shared/models/Alert';
import { AlertService } from 'src/app/shared/services/alert.service';
import { environment } from 'src/environments/environment';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    imports: [CommonModule, FormsModule, RouterModule]
})
export class LoginComponent {
  usrEmail: string = '';
  usrPassword: string = '';
  errorMessage: string = '';
  fieldsCompleted: boolean = false;
  showPassword: boolean = false;
  hoverClassAdded: boolean = false;
  alert: Alert = {} as Alert;

  login: Login = {} as Login;

  constructor(private alertService: AlertService, private router: Router, private loginService: LoginService, private permissionService: PermissionService) {  }

  onSubmit(): void {
    this.login.usrEmail = this.usrEmail;
    this.login.usrPassword = this.usrPassword;

    this.loginService.login(this.login).subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleLoginSuccess(Data)
          : this.handleLoginError(StatusCode),
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        localStorage.setItem('AlertObject', JSON.stringify(this.alert));
        this.alertService.updateAlertState(
          this.alert
        );
        this.clearFields();
      }
    );
  }

  clearFields() {
    this.usrEmail = '';
    this.usrPassword = '';
    this.fieldsCompleted = false;
  }

  handleLoginError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Invalid username or password. Try again.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(
      this.alert
    );
    this.clearFields();
  }

  handleLoginSuccess(token: string) {
    this.permissionService.getFuncionalities().subscribe(
      ({ StatusCode, Message, Data }) => {
        if (Data != null) {

          
          //if (!isDevMode()) {
            localStorage.setItem('UserEmail', this.login.usrEmail);
            this.router.navigate(['/security-verification-options']);
          // }
          // else{
          //   localStorage.setItem('Code', " ");
          //   localStorage.removeItem('UserEmail');
          //   this.router.navigate(['/home']);
          // }
          
        } else {
          this.handleLoginError(StatusCode);
        }
      },
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        localStorage.setItem('AlertObject', JSON.stringify(this.alert));
        this.alertService.updateAlertState(
          this.alert
        );
        this.clearFields();
      }
    );
  }

  checkFields() {
    if (this.usrEmail && this.usrPassword) {
      this.fieldsCompleted = true;
    } else {
      this.fieldsCompleted = false;
    }
  }
  
  togglePasswordVisibility(passwordInput: HTMLInputElement) {
    this.showPassword = !this.showPassword;
    passwordInput.type = this.showPassword ? 'text' : 'password';
  }

  addHoverClass() {
    this.hoverClassAdded = true;
  }

  removeHoverClass() {
    this.hoverClassAdded = false;
  }
}
